import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/LoginPage'
import LogoutPage from '@/components/LogoutPage'
import HomePage from '@/components/HomePage'
import UsersPage from '@/components/UsersPage'
import UserCreatePage from '@/components/UserCreatePage'
import UserPermissionPage from '@/components/UserPermissionPage'
import UserRegistryPage from '@/components/UserRegistryPage'
import CompanyPage from '@/components/CompanyPage'
import CompanyCreatePage from '@/components/CompanyCreatePage'
import CompanyAccessPage from '@/components/CompanyAccessPage'
import PageNotFound from '@/components/PageNotFound'
import ForgotPasswordPage from '@/components/ForgotPasswordPage'
import ResetPasswordPage from '@/components/ResetPasswordPage'
import LockScreenPage from '@/components/LockScreenPage'
import AccountPage from '@/components/AccountPage'

import NotificationsPage from '@/components/NotificationsPage'
import BlankPage from '@/components/BlankPage'

Vue.use(Router)

const verifyUser = (to, from, next) => {
  if (!localStorage.getItem('token') || !localStorage.getItem('vuex')) {
    next({ name: 'LoginPage', params: { errorMessage: 'É preciso realizar login para continuar.' } })
  } else {
    next()
  }
}

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'LoginPage',
      component: LoginPage,
      props: true,
      meta: { bodyClass: 'gray-bg' }
    },
    {
      path: '/logout',
      name: 'LogoutPage',
      component: LogoutPage,
      props: true,
      meta: { bodyClass: 'gray-bg' }
    },
    {
      path: '/home',
      name: 'HomePage',
      component: HomePage,
      meta: { breadcrump: 'Página Principal' },
      beforeEnter: verifyUser
    },
    {
      path: '/users',
      name: 'UsersPage',
      component: UsersPage,
      meta: { breadcrump: 'Usuários' },
      beforeEnter: verifyUser
    },
    {
      path: '/users/create',
      name: 'UserCreatePage',
      component: UserCreatePage,
      meta: { breadcrump: 'Cadastro' },
      beforeEnter: verifyUser
    },
    {
      path: '/users/permissions',
      name: 'UserPermissionPage',
      component: UserPermissionPage,
      meta: { breadcrump: 'Permissões' },
      beforeEnter: verifyUser
    },
    {
      path: '/users/register',
      name: 'UserRegistryPage',
      component: UserRegistryPage,
      meta: { bodyClass: 'gray-bg' }
    },
    {
      path: '/company',
      name: 'CompanyPage',
      component: CompanyPage,
      meta: { breadcrump: 'Clientes' },
      beforeEnter: verifyUser
    },
    {
      path: '/company/create',
      name: 'CompanyCreatePage',
      component: CompanyCreatePage,
      meta: { breadcrump: 'Cadastro' },
      beforeEnter: verifyUser
    },
    {
      path: '/company/access',
      name: 'CompanyAccessPage',
      component: CompanyAccessPage,
      meta: { breadcrump: 'Acessos' },
      beforeEnter: verifyUser
    },
    {
      path: '/forgot-password',
      name: 'ForgotPasswordPage',
      component: ForgotPasswordPage,
      meta: { bodyClass: 'gray-bg' }
    },
    {
      path: '/change-password',
      name: 'ResetPasswordPage',
      component: ResetPasswordPage,
      meta: { bodyClass: 'gray-bg' }
    },
    {
      path: '/lockscreen',
      name: 'LockScreenPage',
      component: LockScreenPage,
      meta: { bodyClass: 'gray-bg' },
      beforeEnter: verifyUser
    },
    {
      path: '/notifications',
      name: 'NotificationsPage',
      component: NotificationsPage,
      meta: { breadcrump: 'Notificações' },
      beforeEnter: verifyUser
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: { bodyClass: 'gray-bg' }
    },
    {
      path: '/account',
      name: 'AccountPage',
      component: AccountPage,
      beforeEnter: verifyUser,
      meta: { breadcrump: 'Minha conta' }
    },
    {
      path: '/blank-page',
      name: 'BlankPage',
      component: BlankPage,
      meta: { breadcrump: 'Página vazia' },
      beforeEnter: verifyUser
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js